
import {EDIT_MESSAGE_ERROR} from "../../reducers/editMessageReducer";


export const editMessageError = (error) =>{
    return {
        type: EDIT_MESSAGE_ERROR,
        payload: {error}
    }
}